
export default {
  name: 'InsurerPageFeatureCard',

  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      dataReady: true,
    }
  },

  computed: {
    insurerPageDetail() {
      if (this.category) {
        const trans = this.category?.insurer_page_trans[0];
        if (trans !== null) {
          if(trans.locale===this.$normalizeLocale(this.$i18n.locale))
          {
            return trans;
          }
          else
          {
            return trans.localizations[0]
          }
        }
      }
      return null;
    },
    backgroundImgPath() {
      if (this.insurerPageDetail) {
        return this.insurerPageDetail.FeatureBackgroundImage?.url
      }
      return null;
    },
    category(){
      if (this.data) {
        const cat = this.data.filter((item) => item.CategoryName === this.$route.params.cat)
        if (cat !== null) {
          if(cat.length > 0)
          {
            return cat[0]
          }
        }
      }
      return null;
    }
  },
  

}
